import {v4 as uuidv4} from 'uuid';

import type {RangesItemDto} from '../typedef';

type CreateRange = {
    rangeId: string,
    rangeData: RangesItemDto,
};
export const createRange = (rangeData: RangesItemDto): CreateRange => {
    return {
        rangeId: uuidv4(),
        rangeData,
    };
};
